// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2527":"a9a455ef","7857":"c06d9bd0","8213":"a3b6ea7a","9296":"4b34d02c"}[chunkId] + ".chunk.css";
};